import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import merge from "lodash.mergewith";

import { MultiImageBlock as MultiImageBlockComponent } from "../MultiImageBlock/MultiImageBlock";
// eslint-disable-next-line import/no-cycle
import { Button as ButtonComponent } from "../Button";
import { Heading } from "../../components/Headings/Heading";

import * as styles from "./ImageBannerWithContent.module.scss";

let cx = classNames.bind(styles);

const ImageBannerWithContent = ({
	contentTitle,
	contentSubtitle,
	contentImagesBlock,
	contentButton,
	customMultiImageBlock,
	customButton,
	customStyles,
}) => {
	let MultiImageBlock = MultiImageBlockComponent;
	let Button = ButtonComponent;

	cx = classNames.bind(merge(customStyles, styles));

	if (customMultiImageBlock) {
		MultiImageBlock = customMultiImageBlock;
	}

	if (customButton) {
		Button = customButton;
	}

	return (
		<div className={cx("bannerContent", "bannerContentCustom")}>
			{contentTitle && (
				<Heading as="h2" size="h1" className={cx("contentHeading", "contentHeadingCustom")}>
					{contentTitle}
				</Heading>
			)}

			{contentSubtitle && (
				<div className={cx("contentText", "contentTextCustom")}>{contentSubtitle}</div>
			)}

			{contentImagesBlock && (
				<div className={cx("multiImageBlockContainer", "multiImageBlockContainerCustom")}>
					<MultiImageBlock
						images={
							contentImagesBlock.cloudinaryImages ||
							(contentImagesBlock.images && contentImagesBlock.images)
						}
						populateImagesRightToLeft={contentImagesBlock.populateImagesRightToLeft}
						populateImagesAsRows={contentImagesBlock.populateImagesAsRows}
						columnProportions={contentImagesBlock.columnProportions}
					/>
				</div>
			)}

			{contentButton && (
				<div className={cx("buttonContainer", "buttonContainerCustom")}>
					<Button
						label={contentButton.text}
						to={contentButton.link}
						icon={contentButton.icon}
						outline
						theme="wedding"
					/>
				</div>
			)}
		</div>
	);
};

ImageBannerWithContent.propTypes = {
	contentTitle: PropTypes.string,
	contentSubtitle: PropTypes.string,
	contentImagesBlock: PropTypes.object,
	contentButton: PropTypes.object,
	customMultiImageBlock: PropTypes.object,
	customButton: PropTypes.object,
	customStyles: PropTypes.object,
};
ImageBannerWithContent.defaultProps = {
	contentTitle: null,
	contentSubtitle: null,
	contentImagesBlock: null,
	contentButton: null,
	customMultiImageBlock: null,
	customButton: null,
	customStyles: null,
};

export default ImageBannerWithContent;
export { ImageBannerWithContent };
